import { cn } from "@/lib/utils";
import type { PartnerBranding, SubPartnerInfo } from "@/hooks/usePartnerBranding";
import type { SidebarClasses } from "./sidebar-theme";

interface PartnerReferralLogosProps {
  branding: PartnerBranding | null;
  subPartner: SubPartnerInfo | null;
  hasPartnerBranding: boolean;
  lightSurface: boolean;
  captions: { partner: string; referral: string };
  classes: SidebarClasses;
}

/** Logos de indicação do parceiro/subparceiro: mantidos como no sidebar anterior (S15). URLs só em `<img src>` (C5). */
export function PartnerReferralLogos(props: PartnerReferralLogosProps) {
  const { branding, subPartner, hasPartnerBranding, lightSurface, captions, classes } = props;
  const logos = [
    { logo: hasPartnerBranding ? branding?.logoIndicacao : null, name: branding?.nome, caption: captions.partner },
    { logo: subPartner?.logoIndicacao, name: subPartner?.nome, caption: captions.referral },
  ].filter((p): p is { logo: string; name: string | undefined; caption: string } => Boolean(p.logo));

  if (logos.length === 0) return null;
  return (
    <div className="flex flex-col gap-2 pb-1">
      {logos.map((p) => (
        <div key={p.caption} className="px-2.5">
          <p className={cn("mb-1.5 text-center text-[10px] uppercase tracking-wider", classes.sealText)}>{p.caption}</p>
          <img
            src={p.logo}
            alt={p.name || p.caption}
            className={cn("mx-auto h-[25px] w-[70px] object-contain", !lightSurface && "brightness-0 invert")}
          />
        </div>
      ))}
    </div>
  );
}
